const Sunshine = [
	'[Verse 1]',
	"Sunshine go away today, I don't feel much like dancin'.",
	"Some man's gone, he's tried to run my life, I don't know what he's askin'.",
	"When he tells me I'd better get in line, I can't hear what he's saying",
	"When I grow up I'm going to make it mine, these ain't dues I been paying",
	'',
	'[Chorus]',
	"Well how much does it cost? (I'll buy it)",
	"The time is all we've lost (I'll try it)",
	"And he can't even run his own life,",
	"I'll be damned if he'll run mine, Sunshine.",
	'',
	'[Verse 2]',
	"Sunshine go away today, I don't feel much like dancin'.",
	"Some man's gone, he's tried to run my life, He don't know what he's askin'.",
	'Working starts to make me wonder where, fruits of what I do are going',
	"When he says in love and war all is fair, He's got cards he ain't showin'.",
	'',
	'[Chorus]',
	"How much does it cost? (I'll buy it)",
	"The time is all we've lost (I'll try it)",
	"And he can't even run his own life,",
	"I'll be damned if he'll run mine, Sunshine.",
	'',
	'[Verse 3]',
	"Sunshine come on back another day, I promise you I'll be singin'.",
	"This old world, she's gonna turn around, brand new bells will be ringin'.",
];

export default Sunshine;
